import React from 'react';
import { RectShape } from 'react-placeholder/lib/placeholders';

import style from './style.module.css'
 
const Placeholder = () => (
  <>
    <div className={style.desktop}>
      <RectShape
        color="#e3e3e3"
        style={{ width: '100%', height: '213px', marginTop: '36px' }}
      />

      <div className={style.flex}>
        <div style={{ flex: 1, paddingRight: '20px' }}>
          <RectShape
            color="#e3e3e3"
            style={{
              width: '80%',
              height: '36px',
              marginTop: '10px',
              marginBottom: '22px'
            }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '79%', height: '36px', marginBottom: '22px' }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '40%', height: '36px', marginBottom: '22px' }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '50%', height: '36px', marginBottom: '22px' }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '75%', height: '36px', marginBottom: '22px' }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '90%', height: '36px', marginBottom: '22px' }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '40%', height: '36px', marginBottom: '22px' }}
          />
        </div>
        <div style={{ flex: 1, paddingTop: '12px' }}>
          <RectShape
            color="#e3e3e3"
            style={{ width: '90%', height: '36px', marginBottom: '22px' }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '100%%', height: '134px' }}
          />
          <RectShape
            color="#e3e3e3"
            style={{
              width: '90%',
              height: '36px',
              marginBottom: '22px',
              marginTop: '20px'
            }}
          />
          <RectShape
            color="#e3e3e3"
            style={{ width: '100%%', height: '134px' }}
          />
        </div>
      </div>
    </div>
    <div className={style.mobile}>
      <RectShape color="#e3e3e3" style={{ width: '100%', height: '200px' }} />

      <div className={style.margin}>

        <RectShape
          color="#e3e3e3"
          style={{ width: '60%', height: '20px', margin: '45px 0 12px 0' }}
        />

        <RectShape
          color="#e3e3e3"
          style={{ width: '40%', height: '20px', margin: '12px 0' }}
        />
        <RectShape
          color="#e3e3e3"
          style={{ width: '80%', height: '20px', margin: '12px 0' }}
        />
        <RectShape
          color="#e3e3e3"
          style={{ width: '50%', height: '20px', margin: '12px 0' }}
        />
        <RectShape
          color="#e3e3e3"
          style={{ width: '65%', height: '20px', margin: '12px 0' }}
        />
        <RectShape
          color="#e3e3e3"
          style={{ width: '40%', height: '20px', margin: '12px 0' }}
        />
        <RectShape
          color="#e3e3e3"
          style={{ width: '80%', height: '20px', margin: '12px 0' }}
        />

      </div>
    </div>
  </>
);


export default Placeholder;
